// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"117f71e4","707":"3424a9dc","729":"cc438e9a"}[chunkId] + ".js";
};